import { graphql } from "gql.tada";
import { RichTextFragment } from "../fragments/RichTextFragment";

export const IntroBenefitsSectionById = graphql(`
  query IntroBenefitsSectionById(
    $locale: String
    $preview: Boolean
    $id: String!
  ) {
    introBenefitsSection(id: $id, preview: $preview, locale: $locale) {
      ...IntroBenefitsSectionFragment
    }
  }

  fragment IntroBenefitsSectionFragment on IntroBenefitsSection {
    benefits_title: title
    iconsCollection(limit: 3) {
      items {
        iconimage {
          url
        }
      }
    }
    benefitItemsCollection(limit: 3) {
      items {
        info {
          json
        }
        background {
          url
        }
        themeColor {
          palette
          foreground
          background
        }
        factSource {
          ...RichTextFragment
        }
      }
    }
  }
`, [RichTextFragment]);
